import { render } from "./ProjectSingleInfo.vue?vue&type=template&id=3f535310"
import script from "./ProjectSingleInfo.vue?vue&type=script&lang=js"
export * from "./ProjectSingleInfo.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__